import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-slate-50 grid place-items-center p-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-8">
        <h1 className="text-xl font-display font-bold text-slate-900">Reset your password</h1>
        {!sent ? (
          <>
            <p className="text-sm text-slate-500 mt-1">We'll email you a secure reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <input type="email" required placeholder="Your email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 border border-slate-300 rounded-xl" data-testid="forgot-email-input" />
              <button disabled={loading} className="w-full bg-[#0F4C81] hover:bg-[#0A365C] text-white rounded-xl py-3 font-semibold" data-testid="forgot-submit-btn">
                {loading ? "Sending..." : "Send reset link"}
              </button>
            </form>
          </>
        ) : (
          <p className="text-sm text-slate-700 mt-3">If an account exists with that email, a reset link has been sent. Check your inbox.</p>
        )}
        <Link to="/doctor/login" className="block mt-5 text-center text-sm text-slate-600 hover:text-slate-900">← Back to sign in</Link>
      </div>
    </div>
  );
}
